export const isWithinReconsentNoticePeriod = (reconsentDue = null) => {
  const now = Math.floor(new Date().getTime() / 1000);
  const oneDay = 86400;
  return reconsentDue ? reconsentDue - now <= oneDay * 30 : false;
};
